// import { hpHttpClient } from 'root/api/http';
import { hpGqlClient } from 'root/api/';
import { crudActions } from 'root/store/helpers';
import { ContractTemplateQuery } from './query';

const { create, filter, fetchMany, getById, update, deleteById, upsert } = hpGqlClient.contractTemplate;

export const actions = {
  ...crudActions('contractTemplate', {
    create, filter, fetchMany, getById, update, deleteById, upsert
  }, {
    queries: ContractTemplateQuery,
  }),
};
